<template>
  <div>
    <van-cell-group>
      <van-field
        v-model="name"
        clearable
        label="患者姓名"
        placeholder="请输入姓名"
      />
      <van-field
        v-model="tel"
        clearable
        maxlength="11"
        type="tel"
        label="患者电话"
        placeholder="请输入电话(非必填)"
      />
      <van-cell
        title="预约日期"
        is-link
        :value="date_value"
        @click="showDateTime"
      />
      <van-cell
        title="预约时间"
        is-link
        :value="time_value"
        @click="showTime"
      />
      <div style="padding: 10px;">
        <van-button
          type="primary"
          size="large"
          @click="addNew"
        >确定</van-button>
      </div>
    </van-cell-group>

    <!--日期-->
    <van-popup
      v-model="date_show"
      position="bottom"
    >
      <van-datetime-picker
        v-model="currentDate"
        type="date"
        :min-date="minDate"
        @cancel="date_show = false"
        @confirm="onDateChange"
      />
    </van-popup>

    <!--时间-->
    <van-popup
      v-model="time_show"
      position="bottom"
    >
      <van-picker
        :columns="timeColumns"
        @cancel="time_show = false"
        @confirm="onTimeChange"
        :show-toolbar="true"
      />
    </van-popup>
  </div>
</template>

<script>
import dayjs from "dayjs";
import TimeMixin from "@/mixins/time";

export default {
  mixins: [TimeMixin],
  data() {
    return {
      name: localStorage.name || "",
      tel: localStorage.tel || "",
      date_value: "",
      time_value: "",

      currentTime: `${new Date().getHours()}:${new Date().getMinutes()}`,
      date_show: false,
      time_show: false,
      minDate:
        new Date().getHours() >= 17
          ? new Date(
              dayjs()
                .add(1, "day")
                .format()
            )
          : new Date(),
      currentDate:
        new Date().getHours() >= 17
          ? new Date(
              dayjs()
                .add(1, "day")
                .format()
            )
          : new Date(),
      baseUrl: "/correct"
    };
  },
  mounted() {},
  methods: {
    getDoctorUseableTime() {
      this.$API
        .get("/doctors/usable_time", {
          rdate: this.date
        })
        .then(data => {
          if (data.code != 0) {
            return this.$toast(data.msg + " ,请更换日期");
          } else {
            this.time_show = true;
            this.timeColumns = data.data.map(item => item.rtime);
          }
        });
    },
    showDateTime() {
      this.date_show = true;
    },
    showTime() {
      this.getDoctorUseableTime();
    },
    onDateChange(value) {
      let format_date = dayjs(value).format("YYYY-MM-DD");
      let date = dayjs(value).format("YYYYMMDD");
      this.date_value = format_date;
      this.date = date;
      this.date_show = false;
    },
    addNew() {
      if (!this.name || !this.date || !this.reTime) {
        return this.$toast("请填写完整信息");
      }

      if (this.tel.length === 8 || this.tel.length === 11) {
        if (this.tel.length === 11) {
          let valid_rule = /^(13[0-9]|14[5-9]|15[012356789]|166|17[0-8]|18[0-9]|19[8-9])[0-9]{8}$/;

          if (!valid_rule.test(this.tel)) {
            return this.$toast("手机号码错误");
          }
        }
      } else {
        if (this.tel.length != 0) {
          return this.$toast("电话号码不符合要求!");
        }
      }

      localStorage.name = this.name;
      localStorage.tel = this.tel;

      let params = {
        openid: localStorage.openid,
        cname: this.name,
        telno: this.tel,
        rdate: this.date,
        rtime: this.reTime
      };

      this.$API.post("/ot_reserves", params).then(data => {
        console.log(data);
        if (data.code != 0) {
          this.$toast(data.msg);
        } else {
          this.$toast("矫正预约成功!");
          localStorage.recent_correct_id = data.data.id;
          setTimeout(() => {
            this.$router.push("/correct_appoint_details?id=" + data.data.id);
          }, 600);
        }
      });
    }
  }
};
</script>

<style scoped>
</style>